import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Line,Card,Column,Panel} from 'ktm-ui';

interface IdsBenCat {
    Id:string;
    CreditCalcMethod:string;
    LSASingleLimit:number;
    LSACoupleLimit:number;
    LSAFamilyLimit:number;
    LSASinglePercent:number;
    LSAcouplePercent:number;
    LSAfamilyPercent:number;
    AllowLSADependentClaims:boolean;
};

export default KTMScreen({name:"enroll.ben-limit.add-lsa"}, class extends React.Component<{policy_id:string, limit_id:string}> {

    data:{
        dsBenCat:IdsBenCat;
    }

    // Store original data for comparison
    originalData: IdsBenCat | null = null;

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenCat";
        await KTMApi.start(screen,{
            "@limit_id":this.props.limit_id,
        });
        screen.title = "Add LSA Benefit";
        await screen.triggerAction(this.set_limit_visibility);
        // Store a copy of the original data
        this.originalData = { ...this.data.dsBenCat };
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Add LSA Benefit"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    limits({field,draw,action}:RenderEvent){
        return (
            <>
                <Line>
                    <Display required field={field("LSASingleLimit")}/>
                    <Display required field={field("LSACoupleLimit")}/>
                    <Display required field={field("LSAFamilyLimit")}/>
                </Line>
            </>
        );
    }

    percentages({field,draw,action}:RenderEvent){
        return (
            <>
                <Line>
                    <Display required field={field("LSASinglePercent")}/>
                    <Display required field={field("LSAcouplePercent")}/>
                    <Display required field={field("LSAfamilyPercent")}/>
                </Line>
            </>
        );
    }

    amounts({field,draw,action}:RenderEvent){
        return (
            <Card>
                {draw(this.limits)}
                {draw(this.percentages)}
            </Card>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.amounts)}
                </Column>
            </Panel>
        );
    }

    getChangedFields(originalData, updatedData) {
        if (!originalData) return {};
  
        const changes = {};
        for (const key in updatedData) {
          if (updatedData[key] !== originalData[key]) {
            changes[key] = {
              oldValue:
                originalData[key] !== undefined ? originalData[key] : "N/A",
              newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
            };
          }
        }
        return changes;
    }

    async submit({screen}:ActionEvent){
         // Track changes
         const changes = this.getChangedFields(
            this.originalData,
            this.data.dsBenCat
        );

        const logDetails = Object.entries(changes)
            .map(([key, value]) => {
            const change = value as { oldValue: any; newValue: any };
            return `${key}: ${change.oldValue} → ${change.newValue}`;
            })
            .join(" | ");

        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note: logDetails,
            Action: "Policy Add LSA Benefit",
            PolicyId: this.props.policy_id,
            }),
        };

        if (this.data.dsBenCat.LSASingleLimit == null)
            this.data.dsBenCat.LSASingleLimit = 0;
        if (this.data.dsBenCat.LSACoupleLimit == null)
            this.data.dsBenCat.LSACoupleLimit = 0;
        if (this.data.dsBenCat.LSAFamilyLimit == null)
            this.data.dsBenCat.LSAFamilyLimit = 0;
        if (this.data.dsBenCat.LSASinglePercent == null)
            this.data.dsBenCat.LSASinglePercent = 0;
        if (this.data.dsBenCat.LSAcouplePercent == null)
            this.data.dsBenCat.LSAcouplePercent = 0;
        if (this.data.dsBenCat.LSAfamilyPercent == null)
            this.data.dsBenCat.LSAfamilyPercent = 0;
        
       
        await KTMApi.action(screen,"submit",{
            "@dsBenCat.LSASingleLimit":this.data.dsBenCat.LSASingleLimit,
            "@dsBenCat.LSACoupleLimit":this.data.dsBenCat.LSACoupleLimit,
            "@dsBenCat.LSAFamilyLimit":this.data.dsBenCat.LSAFamilyLimit,
            "@dsBenCat.LSASinglePercent":this.data.dsBenCat.LSASinglePercent,
            "@dsBenCat.LSAcouplePercent":this.data.dsBenCat.LSAcouplePercent,
            "@dsBenCat.LSAfamilyPercent":this.data.dsBenCat.LSAfamilyPercent,
            "@dsBenCat.AllowLSADependentClaims":this.data.dsBenCat.AllowLSADependentClaims,
            "@limit_id":this.props.limit_id,
        }).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
        screen.close({"continue":true});
    }

    async set_limit_visibility({screen}:ActionEvent){
        screen.hide(this.limits);
        screen.hide(this.percentages);
        if (screen.getValue("@dsBenCat.CreditCalcMethod") == 'SALARY'){
            screen.unhide(this.percentages);
        } else {
            screen.unhide(this.limits);
        }
    }

});
